// Components==============
import React, { createContext, useMemo, useState } from 'react';
// =========================

type GlobalRootPersonContextType = {
  rootPersonModal?: PeopleEntity;
  setRootPersonModal: React.Dispatch<
    React.SetStateAction<PeopleEntity | undefined>
  >;
};

export const GlobalRootPersonContext = createContext(
  {} as GlobalRootPersonContextType
);

export default function GlobalRootPerson({
  children,
}: {
  children: React.ReactNode;
}) {
  const [rootPersonModal, setRootPersonModal] = useState<
    PeopleEntity | undefined
  >(undefined);

  const value = useMemo(
    () => ({
      rootPersonModal,
      setRootPersonModal,
    }),
    [rootPersonModal]
  );

  return (
    <GlobalRootPersonContext.Provider value={value}>
      {children}
    </GlobalRootPersonContext.Provider>
  );
}
